module.exports = __webpack_public_path__ + "media/images/features/premium_plans_img-06804328f0456e18ce1e07487db8c3e1.png";